<template>
  <div class="form-make-out">
    <div v-for="fileInfo in fileInfos" :key="fileInfo.name" class="cn-block">
      <div class="busstype" style="text-align: left;">
        <div class="download-msg">
          <a :href="fileInfo.value[0].url">
            <van-icon name="balance-list-o" size="0.7rem" style="vertical-align: middle; margin-right: 0.2rem;" />
          点击查看{{ fileInfo.name }}</a>
        </div>
      </div>
    </div>
    <van-form @submit="onSubmit" :scroll-to-error="true" :validate-first="true" @failed="onFailed">
      <div v-for="(item, key) in items" :key="item.fieldId">
        <!-- text -->
        <van-field v-if="item.type == 'text' && item.isShow" v-model="item.value" :class="{'red-point': item.rules[0].required}" :name="item.fieldId" :label="item.fieldName" :placeholder="item.placeholder"
          :rules="item.rules" />
        <!-- select -->
        <van-field v-if="(item.type == 'select' || item.type == 'select_cascade') && item.isShow" readonly clickable v-model="item.value" :class="{'red-point': item.rules[0].required}"
         right-icon="arrow-down" :name="item.fieldId" :rules="item.rules" :placeholder="item.placeholder" :label="item.fieldName" @click="clickItem(key, true)" />
        <van-popup v-model="item.showPicker" position="bottom">
          <van-picker show-toolbar :columns="item.columns" @confirm="onConfirm" @cancel="clickItem(key, false)" />
        </van-popup>
        <!-- photo -->
        <van-field v-if="item.type == 'photo' && item.isShow" :name="item.fieldId" class="column-cell" :class="{'red-point': item.rules[0].required}" :label="item.fieldName" :rules="item.rules"
          label-width="100%">
          <template #input>
            <van-uploader v-model="item.value" accept="image/*" :after-read="uploadFile">
              <img v-if="item.fieldId == 'idcards'" class="idcards-img" src="https://cloud.wisewater.cn/group1/M01/10/F9/rBAABWDMNumACfFrAABJtdKZs9g467.png">
              <img v-if="item.fieldId == 'idcardsback'" class="idcards-img" src="https://cloud.wisewater.cn/group1/M01/10/F9/rBAABWDMOHOAUhGNAABlboE9rUU946.png">
            </van-uploader>
          </template>
        </van-field>
        <span class="tips-msg" v-if="item.tips">{{item.tips}}</span>
      </div>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from 'vue'
import { Notify, Dialog, Button, Form, Field, Checkbox, Picker, Uploader, Popup } from 'vant'
import { getBusDetailReq, nextBusinessReq } from '@/api/manage'
import { formDataPost } from '../../utils/axiosfunc'

Vue.use(Button)
Vue.use(Form)
Vue.use(Field)
Vue.use(Checkbox)
Vue.use(Picker)
Vue.use(Uploader)
Vue.use(Popup)
export default {
  data () {
    return {
      temp: '',
      objCommit: {},
      items: [],
      checkbox: true,
      modelId: '',
      linkedId: '',
      userAccount: '',
      userName: '',
      fileInfos: []
    }
  },
  created () {
    const query = this.$route.query
    this.linkedId = query.linkedId
    if (query.userAccount) {
      this.userAccount = query.userAccount
      this.userName = decodeURIComponent(query.userName)
    }

    const params = {
      token: this.$cookies.get('token'),
      openId: this.$cookies.get('openid'),
      linkedId: this.linkedId
    }
    getBusDetailReq(params).then(response => {
      const res = response.data
      if (res.code === 200) {
        // 修改父路由头部文字
        this.$parent.changeBusstypeText(res.data.serviceName, '填报办理信息')
        this.modelId = res.data.modelId
        const formDataString = res.data.formData
        const formData = JSON.parse(formDataString)
        this.items = formData

        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].type === 'text') {
            if (this.items[i].placeholder === '') {
              this.items[i].placeholder = '请输入' + this.items[i].fieldName
            }
            if (this.userAccount !== '' && this.items[i].fieldId === 'userAccount') {
              this.items[i].value = this.userAccount
            } else if (this.userName !== '' && this.items[i].fieldId === 'userName') {
              this.items[i].value = this.userName
            }
          } else if (this.items[i].type === 'select' || this.items[i].type === 'select_cascade') {
            if (this.items[i].placeholder === '') {
              this.items[i].placeholder = '请选择' + this.items[i].fieldName
            }
          } else if (this.items[i].type === 'photo') {
            if (this.items[i].value !== '') {
              const thisFormData = JSON.parse(JSON.stringify(this.items[i])).value.split(',')
              var photoArray = []
              for (let j = 0; j < thisFormData.length; j++) {
                photoArray.push({ url: thisFormData[j] })
              }
              this.items[i].value = photoArray
            } else {
              this.items[i].value = []
            }
            // console.log(this.items[i])
            // this.items[i].rules[0].validator = this.validator
          }
        }

        if (res.data.backendFormData) {
          var backendForm = JSON.parse(res.data.backendFormData)
          for (let i = 0; i < backendForm.length; i++) {
            const estimate = JSON.parse(backendForm[i].value)
            backendForm[i].value = estimate
          }
          this.fileInfos = backendForm
        }
      }
    })
      .catch((res) => {
        console.log(res)
        Notify({ type: 'danger', message: '获取业务信息失败' })
      })
  },
  methods: {
    onFailed (errorInfo) {
      console.log(errorInfo)
      if (!errorInfo.errors[0].message) {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].fieldId === errorInfo.errors[0].name) {
            if (this.items[i].type === 'photo') {
              Dialog({ message: '请上传' + this.items[i].fieldName })
            } else if (this.items[i].type === 'select') {
              Dialog({ message: '请选择' + this.items[i].fieldName })
            } else {
              Dialog({ message: '请填写' + this.items[i].fieldName })
            }
          }
        }
      }
    },
    clickItem (key, show) {
      this.temp = key
      this.items[key].showPicker = show
    },
    onSubmit (values) {
      // Object.assign(values, this.objCommit)
      var formData = JSON.parse(JSON.stringify(this.items))
      for (let i = 0; i < formData.length; i++) {
        const thisFormData = formData[i]
        if (thisFormData.type === 'photo') {
          let value = ''
          for (let j = 0; j < thisFormData.value.length; j++) {
            if (j > 0) {
              value += ','
            }
            value += thisFormData.value[j].url
          }
          thisFormData.value = value
        }
        if (!thisFormData.isShow) {
          thisFormData.value = ''
        }
      }
      const formDataString = JSON.stringify(formData)
      const params = {
        token: this.$cookies.get('token'),
        openId: this.$cookies.get('openid'),
        currentModelId: this.modelId,
        linkedId: this.linkedId,
        data: formDataString,
        type: 0
      }
      nextBusinessReq(params).then(response => {
        const res = response.data
        if (res.code === 200) {
          const localPage = res.data.localPage
          this.$router.push({
            path: localPage,
            query: {
              token: this.$cookies.get('token'),
              linkedId: this.linkedId
            }
          })
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取提交资料失败' })
        })
    },
    onConfirm (value, index) {
      const fieldId = this.items[this.temp].fieldId
      const isShow = this.items[this.temp].isShow
      this.items[this.temp].value = value.text
      // this.items[this.temp].valueText = value.text
      this.items[this.temp].showPicker = false
      this.$set(this.objCommit, this.items[this.temp].fieldId, value.index)

      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i]
        const selectAffect = item.selectAffect
        const parentIndex = item.parentIndex
        const selectParent = item.selectParent
        if (this.items[this.temp].type === 'select' && selectAffect !== undefined) {
          if (fieldId === selectAffect[0]) {
            const selectAffectValArray = selectAffect[1].split(',')
            if (selectAffectValArray.indexOf(index.toString()) > -1 && isShow) {
              item.isShow = true
            } else {
              item.isShow = false
            }
          }
        } else if (this.items[this.temp].type === 'select_cascade' && parentIndex !== undefined) {
          var childrenShow = false
          for (let j = 0; j < parentIndex.length; j++) {
            if (this.items[parentIndex[j]].value === selectParent[j]) {
              childrenShow = true
            } else {
              childrenShow = false
              break
            }
          }
          item.isShow = childrenShow
        }
      }
    },
    uploadFile (file) {
      file.status = 'uploading'
      file.message = '上传中...'
      const url = '/uploadFile'
      const that = this
      const img = new Image() // 创建对象，这个img就是传给上面的compress
      img.src = file.content
      const reader = new FileReader()
      reader.readAsDataURL(file.file)
      img.onload = function () { // 回调
        const idCard = that.compress(img) // 这个id_card就是压缩后的一串base64代码，目测3M图片压缩后800kb
        // 这下面写接口，这里传base64格式给后台
        const formData = new FormData()
        formData.append('file', that.dataURLtoBlob(idCard))

        formDataPost('/business' + url, formData).then(response => {
          const data = JSON.parse(response.request.response)
          console.log(data)
          if (data.code === 200) {
            file.status = 'done'
            file.url = that.filePath + data.fileId
            delete file.file
            delete file.status
            delete file.message
            delete file.content
          } else {
            file.status = 'failed'
            file.message = '上传失败'
          }
        }).catch((res) => {
          file.status = 'failed'
          file.message = '上传失败'
        })
      }
    },
    // 压缩图片
    compress (img) {
      let url = ''
      var w = Math.min(1000, img.width) // 当图片像素>1000的时候，等比例压缩，这个数字可以调
      var h = img.height * (w / img.width)
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      canvas.width = w
      canvas.height = h
      ctx.drawImage(img, 0, 0, w, h)
      url = canvas.toDataURL('image/png', 10) // 1代表精细度，越高越好
      return url
    },
    // base64转Blob
    dataURLtoBlob (dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    }
  }
}
</script>

<style lang="less" scoped>
  .form-make-out {
    margin: 15px;
  }
  .color-red {
    color: red;
  }
  /deep/ .red-point .van-cell__title span::before {
    content: ' *';
    color: red;
  }
  .idcards-img {
    width: 100%;
  }
  .column-cell {
    flex-direction: column;
  }
  .van-field {
    padding-top: 20px;
  }
  /deep/ .van-field__body input[type="text"] {
    // padding: 5px;
    // color: #333;
    font-size: 16px;
    border-bottom: 1px #ccc solid;
    // background-color: #F5EFEF;
  }
  .cn-block .busstype {
    background-color: #ffffff;
    padding: 15px 10px;
    text-align: center;
    margin: 20px 0;
    color: #727272;
    font-size: 16px;
    -webkit-box-shadow: #999 0px 0px 5px;
    -moz-box-shadow: #999 0px 0px 5px;
    box-shadow: #999 0px 0px 5px;
    line-height: 25px;
    border-radius: 4px;
    position: relative;
    margin-bottom: 30px;
  }
  .cn-block .busstype:not(:last-child)::after {
    position: absolute;
    bottom: -9px;
    left: 49%;
    content: '';
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #ffffff;
    filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, .2));
  }
  .cn-block .busstype:last-child::after {
    background-color: #ffffff;
    padding: 15px 10px;
    text-align: center;
    margin: 20px 30px;
    color: #727272;
    font-size: 16px;
    -webkit-box-shadow: #999 0px 0px 5px;
    -moz-box-shadow: #999 0px 0px 5px;
    box-shadow: #999 0px 0px 5px;
    line-height: 25px;
    border-radius: 4px;
    position: relative;
    margin-bottom: 30px;
  }
  .cn-block .busstype .download-msg a {
    width: 100%;
    color: #1EB1E7;
    display: inline-block;
  }
  .tips-msg {
    display: flex;
    height: auto;
    margin: 0;
    font-size: 12px;
    line-height: 1.2;
    text-indent: 12px;
    letter-spacing: 1.5px;
    color: red;
    background-color: #ffffff;
    padding-left: 10px;
  }
</style>
